import Nullstack from 'nullstack';
export default function IconAddressBookOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-address-book-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M8 4h10a2 2 0 0 1 2 2v10m-.57 3.399c-.363 .37 -.87 .601 -1.43 .601h-10a2 2 0 0 1 -2 -2v-12"
  }), "   ", Nullstack.element("path", {
    d: "M10 16h6"
  }), "   ", Nullstack.element("path", {
    d: "M11 11a2 2 0 0 0 2 2m2 -2a2 2 0 0 0 -2 -2"
  }), "   ", Nullstack.element("path", {
    d: "M4 8h3"
  }), "   ", Nullstack.element("path", {
    d: "M4 12h3"
  }), "   ", Nullstack.element("path", {
    d: "M4 16h3"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}